/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IColorpaletteViewProps } from './colorpalette';

export default (props: IColorpaletteViewProps) => {
    return (
        <div className='color-palette example'>
            <h1>Primary &amp; Secondary Brand Colors</h1>
            <table>
                <tr>
                    <td className='cirrus-black'>
                        <br />
                        <br />
                    </td>
                    <td className='cirrus-white'>
                        <br />
                        <br />
                    </td>
                </tr>
                <tr>
                    <td>
                        Primary
                        <br />
                        #000000
                    </td>
                    <td>
                        Secondary
                        <br />
                        #FFFFFF
                    </td>
                </tr>
            </table>
            <br />
            <br />
            <h1>Greyscale</h1>
            <table>
                <tr>
                    <td className='msv-gray-1-custom'>
                        <br />
                        Gray L1
                        <br />
                    </td>
                    <td className='msv-gray-2-custom'>
                        <br />
                        Gray L2
                        <br />
                    </td>
                    <td className='msv-gray-3-custom'>
                        <br />
                        Gray L3
                        <br />
                    </td>
                    <td className='msv-gray-4-custom'>
                        <br />
                        Gray L4
                        <br />
                    </td>
                    <td className='msv-gray-5-custom'>
                        <br />
                        Gray L5
                        <br />
                    </td>
                    <td className='msv-gray-6-custom'>
                        <br />
                        Gray L6
                        <br />
                    </td>
                    <td className='msv-gray-7-custom'>
                        <br />
                        Gray L7
                        <br />
                    </td>
                    <td className='msv-gray-8-custom'>
                        <br />
                        Gray L8
                        <br />
                    </td>
                </tr>
                <tr>
                    <td>HEX: #454546</td>
                    <td>HEX: #5C5C5E</td>
                    <td>HEX: #707174</td>
                    <td>HEX: #808285</td>
                    <td>
                        DEFAULT
                        <br />
                        HEX: #959799
                    </td>
                    <td>HEX: #A8AAAD</td>
                    <td>HEX: #BCBEC0</td>
                    <td>HEX: #D1D2D4</td>
                </tr>
            </table>
            <br />
            <h1>Bluescale</h1>
            <table>
                <tr>
                    <td className='msv-blue-1-custom'>
                        <br />
                        Blue L1
                        <br />
                    </td>
                    <td className='msv-blue-2-custom'>
                        <br />
                        Blue L2
                        <br />
                    </td>
                    <td className='msv-blue-3-custom'>
                        <br />
                        Blue L3
                        <br />
                    </td>
                    <td className='msv-blue-4-custom'>
                        <br />
                        Blue L4
                        <br />
                    </td>
                    <td className='msv-blue-5-custom'>
                        <br />
                        Blue L5
                        <br />
                    </td>
                    <td className='msv-blue-6-custom'>
                        <br />
                        Blue L6
                        <br />
                    </td>
                    <td className='msv-blue-7-custom'>
                        <br />
                        Blue L7
                        <br />
                    </td>
                    <td className='msv-blue-8-custom'>
                        <br />
                        Blue L8
                        <br />
                    </td>
                </tr>
                <tr>
                    <td>
                        DEFAULT
                        <br />
                        HEX: #0D1733
                    </td>
                    <td>HEX: #162646</td>
                    <td>HEX: #1D3455</td>
                    <td>HEX: #233F63</td>
                    <td>HEX: #2D547E</td>
                    <td>HEX: #335E8D</td>
                    <td>HEX: #38679B</td>
                    <td>HEX: #4279B8</td>
                </tr>
            </table>
            <br />
            <h1>User Feedback &amp; Alerts</h1>
            <table>
                <tr>
                    <td className='cirrus-error'>
                        <strong>Error</strong>
                    </td>
                    <td className='cirrus-success'>
                        <strong>Success</strong>
                    </td>
                    <td className='cirrus-alert'>
                        <strong>Alert</strong>
                    </td>
                    <td className='cirrus-warning'>
                        <strong>Warning</strong>
                    </td>
                    <td className='cirrus-instruction'>
                        <strong>Instruction</strong>
                    </td>
                </tr>
                <tr>
                    <td>HEX: #9A212A</td>
                    <td>HEX: #107C10</td>
                    <td>HEX: #FDB52B</td>
                    <td>HEX: #E65722</td>
                    <td>HEX: #2266E3</td>
                </tr>
            </table>
            <br />
        </div>
    );
};
